import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {allConfig, generateRoute, tabConfig} from './activity-report.config';
import {ActivitySheetStatusEnum} from './models/activity-sheet.model';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'all',
    pathMatch: 'full',
  },
  generateRoute(allConfig, null, 'all'),
  generateRoute(tabConfig, ActivitySheetStatusEnum.DRAFT, ActivitySheetStatusEnum.DRAFT),
  generateRoute(tabConfig, ActivitySheetStatusEnum.SUBMITTED, ActivitySheetStatusEnum.SUBMITTED),
  generateRoute(tabConfig, ActivitySheetStatusEnum.VALIDATED, ActivitySheetStatusEnum.VALIDATED),
  generateRoute(tabConfig, ActivitySheetStatusEnum.REFUSED, ActivitySheetStatusEnum.REFUSED),
  generateRoute(tabConfig, ActivitySheetStatusEnum.CANCELLED, ActivitySheetStatusEnum.CANCELLED),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActivityReportRoutingModule {
}
